/* DI MARTINO MAISON · runtime (vanilla) */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var FADE_MS = 500, FADE_OUT_LEAD = 0.55, EASE = 'cubic-bezier(0,0,0.58,1)';

  /* FadingVideo: crossfade por requestAnimationFrame, loop manual */
  function fadingVideo(v) {
    if (v.__m) return; v.__m = true;
    var raf = null, out = false;
    v.loop = false; v.muted = true; v.playsInline = true; v.style.opacity = '0';
    function fadeTo(t, d) {
      if (raf) cancelAnimationFrame(raf);
      var from = parseFloat(v.style.opacity); if (isNaN(from)) from = 0;
      var s = null;
      (function step(ts) { if (s === null) s = ts; var k = Math.min((ts - s) / d, 1);
        v.style.opacity = String(from + (t - from) * k); raf = k < 1 ? requestAnimationFrame(step) : null; })(performance.now());
    }
    function play() { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
    function loaded() { v.style.opacity = '0'; play(); fadeTo(1, FADE_MS); }
    function time() { var r = v.duration - v.currentTime; if (!out && r <= FADE_OUT_LEAD && r > 0) { out = true; fadeTo(0, FADE_MS); } }
    function ended() { v.style.opacity = '0'; setTimeout(function () { v.currentTime = 0; play(); out = false; fadeTo(1, FADE_MS); }, 100); }
    v.addEventListener('loadeddata', loaded); v.addEventListener('timeupdate', time); v.addEventListener('ended', ended);
    if (v.readyState >= 2) loaded();
  }

  /* Reveal suave */
  function reveal(el) {
    if (el.__mr) return; el.__mr = true;
    var d = parseFloat(el.getAttribute('data-m-reveal')) || 0;
    if (reduce || !el.animate) { el.style.opacity = 1; el.style.filter = 'none'; el.style.translate = 'none'; return; }
    var a = el.animate([{ opacity: 0, filter: 'blur(8px)', translate: '0 18px' }, { opacity: 1, filter: 'blur(0px)', translate: '0 0' }],
      { duration: 900, delay: d * 1000, easing: EASE, fill: 'both' });
    /* Al terminar: fija el estado final sin filtro ni desplazamiento y suelta la animación,
       así el texto vuelve a dibujarse nítido (en iOS el filtro persistente lo deja difuso). */
    a.onfinish = function () { el.style.opacity = '1'; el.style.filter = 'none'; el.style.translate = 'none'; el.style.willChange = 'auto'; a.cancel(); };
  }
  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) { reveal(e.target); io.unobserve(e.target); } });
  }, { threshold: 0.12 }) : null;

  /* Hero: slides con crossfade */
  function hero(root) {
    if (root.__mh) return; root.__mh = true;
    var slides = root.querySelectorAll('.m-slide'); if (!slides.length) return;
    var dots = root.querySelectorAll('.m-hero__dots button');
    var num = root.querySelector('[data-m-num]'); var bar = root.querySelector('.m-hero__bar');
    var ms = (parseFloat(root.getAttribute('data-interval')) || 6) * 1000, i = 0, timer = null;
    function go(n) {
      slides[i].classList.remove('is-active'); if (dots[i]) dots[i].classList.remove('is-active');
      i = (n + slides.length) % slides.length;
      slides[i].classList.add('is-active'); if (dots[i]) dots[i].classList.add('is-active');
      if (num) num.textContent = i + 1;
      slides[i].querySelectorAll('[data-m-reveal]').forEach(function (el) { el.__mr = false; reveal(el); });
      if (bar && slides.length > 1) { bar.classList.remove('is-run'); void bar.offsetWidth; bar.querySelector('i').style.animationDuration = ms + 'ms'; bar.classList.add('is-run'); }
      clearTimeout(timer); if (slides.length > 1 && !reduce) timer = setTimeout(function () { go(i + 1); }, ms);
    }
    dots.forEach(function (b, k) { b.addEventListener('click', function () { go(k); }); });
    go(0);
  }

  /* Header: cambia a tinta cuando pasa sobre secciones claras */
  function headerTone() {
    var h = document.querySelector('.m-head'); if (!h) return;
    var y = h.getBoundingClientRect().bottom - 8, tone = 'light';
    document.querySelectorAll('[data-m-tone]').forEach(function (s) {
      var r = s.getBoundingClientRect(); if (r.top <= y && r.bottom > y) tone = s.getAttribute('data-m-tone');
    });
    h.classList.toggle('is-light', tone !== 'dark');
  }

  function init(root) {
    root = root || document;
    root.querySelectorAll('video[data-m-fading]').forEach(fadingVideo);
    root.querySelectorAll('.m-hero').forEach(hero);
    root.querySelectorAll('[data-m-reveal]').forEach(function (el) { if (el.closest('.m-slide')) return; io ? io.observe(el) : reveal(el); });
    headerTone();
  }
  window.addEventListener('scroll', headerTone, { passive: true });
  window.addEventListener('resize', headerTone);

  document.addEventListener('click', function (e) {
    var d = document.querySelector('.m-drawer'); if (!d) return;
    if (e.target.closest('[data-m-open]')) { d.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
    if (e.target.closest('[data-m-close]')) { d.classList.remove('is-open'); document.body.style.overflow = ''; }
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var s = e.target.closest('.m-hero'); if (!s) return;
    var all = Array.prototype.slice.call(s.querySelectorAll('.m-slide')); var k = all.indexOf(e.target);
    if (k > -1) { all.forEach(function (x) { x.classList.remove('is-active'); }); e.target.classList.add('is-active'); }
  });
})();
